module.exports = __webpack_public_path__ + "static/media/select-light.bf333ba3.svg";